<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="bmsjHipsterApp.sample.genotypes.header">Import Genotypes</span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
		(click)="close()">
	</button>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-md-12">
			<span jhiTranslate="bmsjHipsterApp.sample.genotypes.markers.select.study.description"></span>
			<br><br>
		</div>
	</div>
	<div class="mb-3 row">
		<label class="col-3 col-form-label">
			<label class="col-form-label" jhiTranslate="bmsjHipsterApp.sample.genotypes.study.label">Genotyping Study:</label>
		</label>
		<div class="col-8">
			<div class="mb-3">
				<select style="width: 85%" [disabled]="!genotypingStudies || genotypingStudies?.length === 0" class="form-select" name="genotypingStudy" id="genotypingStudy" [(ngModel)]="selectedGenotypingStudy" (ngModelChange)="selectStudyOnChange()" #genotypingStudy="ngModel">
					<option value="" jhiTranslate="global.please.choose">Please Choose</option>
					<option *ngFor="let item of genotypingStudies" [ngValue]="item">{{item.studyName}}</option>
				</select>
			</div>
		</div>
        <div class="col-1">
           <span *ngIf="isStudyLoading" class="throbber"></span>
        </div>
	</div>
	<div class="mb-3 row">
		<label class="col-3 col-form-label">
			<label class="col-form-label" jhiTranslate="bmsjHipsterApp.sample.genotypes.run.label">Run:</label>
		</label>
		<div class="col-8">
			<div class="mb-3">
				<select style="width: 85%" [disabled]="!genotypingVariantsets || genotypingVariantsets?.length === 0" class="form-select" name="variantSetSelect" id="variantSetSelect" [(ngModel)]="selectedVariantSet" (ngModelChange)="selectVariantsetOnChange()" #variantSetSelect="ngModel">
					<option value="" jhiTranslate="global.please.choose">Please Choose</option>
					<option *ngFor="let item of genotypingVariantsets" [ngValue]="item">{{item.variantSetName}}</option>
				</select>
			</div>
			<div *ngIf="selectedVariantSet" class="row">
				<span jhiTranslate="bmsjHipsterApp.sample.genotypes.selected.study.summary.description" [translateValues]="{param1: selectedVariantSet.callSetCount, param2: selectedVariantSet.variantCount}"></span>
			</div>
		</div>
        <div class="col-1">
            <span *ngIf="isVariantSetLoading" class="throbber"></span>
        </div>
	</div>
	<hr *ngIf="isMarkerMappingVisible()">
	<div class="mb-3 row" *ngIf="isMarkerMappingVisible()">
		<label class="fw-bold" jhiTranslate="bmsjHipsterApp.sample.genotypes.mapped.header">Mapped Variants</label>
	</div>
	<div class="row" *ngIf="isMarkerMappingVisible()">
		<div class="col-md-12">
			<span jhiTranslate="bmsjHipsterApp.sample.genotypes.markers.map.description" [translateValues]="{param1: MARKER_MAPPING_ITEM_COUNT_LIMIT}"></span>
			<br><br>
		</div>
	</div>
	<div class="mb-3 row" *ngIf="isMarkerMappingVisible()">
		<div class="col-md-12">
			<div *ngIf="isVariantsLoading" class="row">
				<div class="col">
					<span class="throbber"></span>&nbsp;
					<span jhiTranslate="bmsjHipsterApp.sample.genotypes.loading.markers">Loading the markers list. Please wait.</span>
				</div>
			</div>
			<div *ngIf="!isVariantsLoading" class="table-responsive">
                <div class="custom-scroll-style" style="min-height: 300px; max-height: 500px; overflow-y: auto">
				<table class="table table-striped table-bordered table-curved" *ngIf="((mappedVariants && mappedVariants.size) || showAddMappingRow) else nodata">
					<thead class="sticky-header">
					<tr>
						<th jhiTranslate="bmsjHipsterApp.sample.genotypes.marker.column">Marker</th>
						<th jhiTranslate="bmsjHipsterApp.sample.genotypes.variable.column">Variable</th>
						<th jhiTranslate="bmsjHipsterApp.sample.genotypes.action.column">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let item of mappedVariants.values()">
						<td>{{item.variant.variantName}}</td>
						<td>{{item.variable.name}}</td>
						<td class="fit">
							<button class="btn btn-info me-2" (click)="removeMappedVariant(item.variant.variantDbId)">
								<i class="fa fa-trash fa-md" aria-hidden="true"></i>
							</button>
						</td>
					</tr>
					<tr *ngIf="showAddMappingRow">
						<td>
							<ng-select #rowVariantSelect
									   [ngStyle]="{'min-width': '85%'}"
									   placeholder="{{ 'bmsjHipsterApp.sample.genotypes.select.marker' | translate }}"
									   [items]="variantSelectItems" [(ngModel)]="selectedVariantItem"
									   [disabled]="!variantSelectItems || variantSelectItems?.length === 0"
									   bindLabel="variantName"
									   [searchFn]="searchVariant"
									   name="rowVariantSelect" id="rowVariantSelect"
									   [dropdownPosition]="'bottom'"
									   [virtualScroll]="true">
								<ng-template ng-option-tmp let-variant="item">
									<div title="{{variant.variantName}}">{{variant.variantName}}</div>
								</ng-template>
							</ng-select>
						</td>
						<td>
							<jhi-variable-select name="dropdownRowVariable" id="dropdownRowVariable"
												 (onVariableSelectedChange)="selectVariable($event)"
												 [value]="selectedVariable?.id"
												 [variableTypeIds]="[genotypeMarkersId]"
												 [disabled]="!variantSelectItems || variantSelectItems?.length === 0">
							</jhi-variable-select>
						</td>
						<td class="fit">
							<button type="button" class="btn btn-primary" [disabled]="!selectedVariantItem || !selectedVariable" (click)="mapVariant()">Map</button>
						</td>
					</tr>
					</tbody>
				</table>
                </div>
				<button type="button" class="btn btn-primary" *ngIf="showAddMappingButton()" [disabled]="!variantSelectItems || variantSelectItems?.length === 0" (click)="addMapping()">
					<span jhiTranslate="bmsjHipsterApp.sample.genotypes.add.another.mapping">Add another mapping</span>
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" (click)="close()" aria-hidden="true">
        <span jhiTranslate="entity.action.cancel">Cancel</span>
	</button>
	<button type="button" class="btn btn-primary ms-2" [disabled]="!mappedVariants || mappedVariants.size === 0" (click)="importGenotypes()"
		jhiTranslate="entity.action.import">Import
		<span *ngIf="isGenotypesSaving" class="throbber"></span>
	</button>
</div>

<ng-template #nodata>
	<table class="table table-striped table-bordered table-curved">
		<thead>
		<tr>
			<th></th>
		</tr>
		</thead>
		<tbody>
		<tr>
			<td jhiTranslate="bmsjHipsterApp.sample.genotypes.no.mapped.markers"></td>
		</tr>
		</tbody>
	</table>
</ng-template>
